module.exports = __webpack_public_path__ + "f4d347568b261e074f2f524cd9bc7ea5.png";